export enum AntiFraudAlertRule {
    requisite_device_change_rule = 'requisite_device_change_rule',
    tg_user_change_rule = 'tg_user_change_rule',
    pay_in_canceled_deals_check = 'pay_in_canceled_deals_check',
    uzs_pay_in_canceled_deals_count_check = 'uzs_pay_in_canceled_deals_count_check',
    pay_in_canceled_deals_count_check = 'pay_in_canceled_deals_count_check',
    pay_out_completed_deals_check = 'pay_out_completed_deals_check',
    pay_out_receipt_verification_rule = 'pay_out_receipt_verification_rule',
    active_disputes_count_check = 'active_disputes_count_check',
    pay_out_stopscam_receipt_check = 'pay_out_stopscam_receipt_check',
}